import api from 'shared/api/westeros';
import { BUKAREKSA_TAG_ID, BUKAREVIEW_WEBSITE_ID } from 'shared/constants/kontenz';

export default {
  async retrieveMutualFundProducts({ commit }) {
    try {
      const { data: mutualFundProducts } = await api.getProducts();

      commit('setMutualFundProducts', mutualFundProducts);

      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  },

  async retrieveMutualFundVideos({ commit }) {
    try {
      const { data: mutualFundVideos } = await api.getVideo();

      commit('setMutualFundVideos', mutualFundVideos);

      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  },

  async retrieveMutualFundArticles({ commit }) {
    try {
      const { data: mutualFundArticles } = await api.getArticles({
        id: BUKAREVIEW_WEBSITE_ID,
        limit: 4,
        origin: 'review',
        tag_id: BUKAREKSA_TAG_ID,
      });

      commit('setMutualFundArticles', mutualFundArticles);

      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  },

  async retrieveMutualFundTestimonies({ commit }) {
    try {
      const { data: mutualFundTestimonies } = await api.getTestimonies();

      commit('setMutualFundTestimonies', mutualFundTestimonies);

      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  },
};
